import api from '../api';
import { ExameItem, ApiError } from './types';

export class ExameService {
  /**
   * Lista todos os exames disponíveis
   * @returns Promise com array de exames
   */
  static async getExames(): Promise<ExameItem[]> {
    try {
      const response = await api.get<ExameItem[]>('/exames');
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Busca um exame específico por ID
   * @param id - ID do exame
   * @returns Promise com dados do exame
   */
  static async getExameById(id: number): Promise<ExameItem> {
    try {
      const response = await api.get<ExameItem>(`/exames/${id}`);
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || 'Erro na requisição',
        statusCode: error.response.status,
        error: error.response.data.error,
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}
